/**
 * Returns true if the code is alphanumeric and of length 6
 * @param {string} code - Either a OneID or Adobe Reg Code
 */
export default (code = '') => /^[a-z0-9]+$/i.test(code) && code.length === 6;



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/util/isOneIdRegCode.js